import { TransactionsReportTranslations } from "./transactions-report-pt-br";

export const TRANSACTIONS_REPORT_EN_US: TransactionsReportTranslations = {
	title: "Transaction List",
	descriptionPlace: "List of all transactions for the period",
	descriptionEvent: "List of all transactions for the event",
	filter: {
		title: "Filter",
		emptyFilter: "Click to filter",
		modal: {
			inputPlaceholder: "Type here",
			selectPlaceholder: "Select here",
			descriptionEnd: "to filter transactions",
		},
		modalOptions: {
			terminal: {
				label: "Terminal",
				title: "Terminal number",
				description: "Enter terminal number",
			},
			clientDocument: {
				label: "Customer document",
				title: "CPF or document number",
				description: "Enter the customer's CPF or document number",
			},
			employee: {
				label: "Employee",
				title: "Employee name",
				description: "Enter employee name",
			},
			zigCode: {
				label: "ZigCode",
				description: "Enter ZigCode number",
			},
			paymentMethod: {
				label: "Payment method",
				description: "Select a payment method",
			},
			transactionType: {
				label: "Transaction type",
				description: "Select a transaction type",
			},
			bar: {
				label: "Filter by bar",
				title: "Bar",
				description: "Select a bar",
			},
		},
	},
	print: "Print report",
	table: {
		id: "ID",
		date: "Date",
		syncDate: "Sync date",
		type: "Type",
		employee: "Employee",
		terminal: "Terminal Serial",
		deviceId: "Device ID",
		zigCode: "ZigCard",
		bar: "Bar",
		client: "Client",
		product: "Product",
		quantity: "Quantity",
		source: "Source",
		paymentMethod: "Payment method",
		status: "Status",
		paidInOtherEvent: "Paid in other event",
		document: "document",
		acquirer: "Acquirer",
		acquirerTransactionId: "Acquiring Transaction ID",
		cardBrand: "Card Brand",
		nsu: "NSU",
		nsuHost: "NSU Host",
		authorizationCode: "Authorization Code",
		bin: "Bin",
		service: "Service",
		value: "Value",
		hawkerDocument: "Harker Document",
		hawkerName: "Hawker Name",
	},
	transactionTypes: {
		recharge: "Recharge",
		transaction: "Transaction",
		ficha: "Token",
		canceled: "Cancelled",
		refund: "Refund",
		digitalCashless: "Digital Cashless",
	},
	maxSearchPeriod: "The maximum search period is 31 days",
	exportExcel: {
		success: "Export email sent successfully.",
		title: "Export report",
		label: "Please enter your email address to send the spreadsheet",
		error: "Enter a valid email address",
		placeholder: "Enter your email address",
	},
};
